// src/constants/clabSelectionTabs.js
import { APP_STATUS } from './statusUtils';

/**
 * Tab configuration for CLAB Selection Requests
 * Centralized configuration for better maintainability
 */
export const CLAB_SELECTION_TABS = [
  {
    key: "pending",
    label: "Pending",
    status: APP_STATUS.PENDING,
    icon: "Clock",
    color: "text-warning-600",
    description: "Applications awaiting review",
  },
  {
    key: "approved",
    label: "Approved",
    status: APP_STATUS.APPROVED,
    icon: "CheckCircle",
    color: "text-success-600",
    description: "Applications that have been approved",
  },
  {
    key: "rejected",
    label: "Rejected",
    status: APP_STATUS.REJECTED,
    icon: "XCircle",
    color: "text-error-600",
    description: "Applications that have been rejected",
  },
  {
    key: "resubmitted",
    label: "Resubmitted",
    status: APP_STATUS.RESUBMIT,
    icon: "RefreshCw",
    color: "text-accent-600",
    description: "Applications that have been resubmitted",
  },
];

/**
 * Get tab configuration by key
 * @param {string} tabKey - The tab key to find
 * @returns {Object|undefined} Tab configuration object
 */
export const getTabByKey = (tabKey) => {
  return CLAB_SELECTION_TABS.find(tab => tab.key === tabKey);
};

/**
 * Get all tab keys
 * @returns {string[]} Array of tab keys
 */
export const getTabKeys = () => {
  return CLAB_SELECTION_TABS.map(tab => tab.key);
};

/**
 * Default tab key
 */
export const DEFAULT_TAB = "pending";

export default CLAB_SELECTION_TABS;